// extracted by mini-css-extract-plugin
module.exports = {"container":"LocaleSelect_container__5_EbW","localeSelect":"LocaleSelect_localeSelect__2o0hW"};